import React from 'react';
import Wrapper from './Wrapper';

function Footer() {
  return (
    <Wrapper>
      <section>huisjeinsauerland</section>
      <section>Oberhundem</section>
    </Wrapper>
  );
}

export default Footer;
